<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_managerolecompany/_update/updateGroup.vue'
export default {
  components: {
    createContent
  }
}
</script>
